import { ACTION_SUBJECT, EVENT_TYPE, INPUT_METHOD } from '@atlaskit/editor-common/analytics';
import { withAnalytics } from '@atlaskit/editor-common/editor-analytics';
import { InputSource } from './enums';
import { pluginKey as undoPluginKey } from './plugin-key';
export var attachInputMeta = function attachInputMeta(inputSource) {
  return function (command) {
    return function (state, dispatch) {
      var customTr = state.tr;
      var fakeDispatch = function fakeDispatch(tr) {
        customTr = tr;
      };
      command(state, fakeDispatch);
      if (!customTr || !customTr.docChanged) {
        return false;
      }
      customTr.setMeta(undoPluginKey, inputSource);
      if (dispatch) {
        dispatch(customTr);
      }
      return true;
    };
  };
};
var inputSourceToInputMethod = function inputSourceToInputMethod(inputSource) {
  switch (inputSource) {
    case InputSource.EXTERNAL:
      return INPUT_METHOD.EXTERNAL;
    case InputSource.KEYBOARD:
      return INPUT_METHOD.KEYBOARD;
    case InputSource.TOOLBAR:
      return INPUT_METHOD.TOOLBAR;
    default:
      return INPUT_METHOD.EXTERNAL;
  }
};
export var attachInputMetaWithAnalytics = function attachInputMetaWithAnalytics(editorAnalyticsAPI) {
  return function (inputSource, action) {
    return function (command) {
      return attachInputMeta(inputSource)(withAnalytics(editorAnalyticsAPI, {
        eventType: EVENT_TYPE.TRACK,
        action: action,
        actionSubject: ACTION_SUBJECT.EDITOR,
        attributes: {
          inputMethod: inputSourceToInputMethod(inputSource)
        }
      })(command));
    };
  };
};